/**
 * Configurazione centralizzata degli endpoint API
 * IMPORTANTE: Non modificare manualmente gli URL
 * Tutte le chiamate API devono utilizzare questa configurazione
 */

// Ottiene la base URL dalle variabili d'ambiente
export const getApiBaseUrl = () => {
    return import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080';
};

// Genera l'URL completo per una chiamata API al server Node
export const getNodeApiUrl = (endpoint) => {
    const baseUrl = getApiBaseUrl();
    
    // Verifica che l'endpoint sia definito e sia una stringa
    if (!endpoint) {
        console.warn('getNodeApiUrl: endpoint non definito');
        return baseUrl;
    }
    
    // Se l'endpoint inizia già con slash, non aggiungere slash doppi
    if (typeof endpoint === 'string' && endpoint.startsWith('/')) {
        return `${baseUrl}${endpoint}`;
    }
    
    return `${baseUrl}/${endpoint}`;
};

// Export default per retrocompatibilità
export default {
    getApiBaseUrl,
    getNodeApiUrl
};
